import React, { useContext, useEffect, useState } from 'react'
import { CarOrderingContext } from "../../CarOrdering";
import classNames from "classnames"
import handlePushState from "../../misc/handlePushState";

export default function TopNavigation() {
  const {
    car,
    currentStep,
    endpoints,
    steps,
    isMenuOpen,
    setCurrentStep,
    setInteriorImage,
    setIsMenuOpen,
    validSteps
  } = useContext(CarOrderingContext)

  const changeStep = function (step) {
    if (! validSteps.includes(step.id)) {
      return
    }

    if (steps.find((s) => s.id === step.id)) {
      setInteriorImage(null)
      setCurrentStep(step)

      handlePushState(endpoints.order, step.id, car.slug)
    }

    setIsMenuOpen(false)
  }

  const stepElements = steps.map((step, index) => {
    return (
      <aside
        key={index + 1}
        id={`step-${step.id}`}
        className='step'
        onClick={() => changeStep(step)}
        data-active={currentStep.id === step.id}
        data-step-is-valid={validSteps.includes(step.id)}
      >
        <span>{step.id}.</span>
        &nbsp;
        {step.title}
      </aside>
    )
  })

  return (
    <div className={classNames('top-navigation', { 'open': isMenuOpen })}>
      {stepElements}
    </div>
  )
}
